module.exports = __webpack_public_path__ + "static/media/arrow.4a7636d4.svg";